export default "__VITE_ASSET__89fe010d__"